import React from "react";
import QuestionSection from "../tabViews/QuestionSection";
import { getAllDataInSection } from "../data/flowChartData.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/nav.scss";

const w = window;

class ClinicalToolFlow extends React.Component {
  constructor(props) {
    super(props);

    this.clickedBack = this.clickedBack.bind(this);
    this.answerSelected = this.answerSelected.bind(this);
  }

  answerSelected(category, answer, value) {
    if (typeof(value) === 'string' && value.length > 0) {
      w[category] = value;
    } else {
      w[category] = answer;
    }
    this.forceUpdate();
  }

  createCategories(id) {
    if (typeof w[id] === "undefined" && id) {
      w[id] = 0;
    }
  }

  buildPostContent(data) {
    let postText = [];
    data.forEach((post) => {
      if (post.calc) {
        eval('window.value = ' + post.calc + ";");
      }
      if (eval(post.visible)) {
        postText.push({
          style: post.style || "light",
          align: post.align || "left",
          text: post.text
        });
      }
    });
    return postText;
  }

  clickedBack() {
    this.props.restart();
    window.scrollTo({
      top: 0,
    });
  }

  render() {
    const data = getAllDataInSection(this.props.category);
    const questions = data.content.filter(c => c.type);
    questions.forEach((question) => {
      this.createCategories(question.id);
    });
    if (data.eval) {
      data.eval.forEach( e => {
        eval('window.' + e);
      });
    }
    const post_content = data.content.filter( c => !c.type)

    return (
      <div id="management_form" className="form card-holder">
        <QuestionSection
          visibleQuestions={questions}
          title={this.props.title}
          postContent={this.buildPostContent(post_content)}
          answerSelected={this.answerSelected}
          color={this.props.color}
          tab={"tools"}
        />
        <button
          id="management_back"
          className="back btn btn-secondary"
          value="&lt Back"
          onClick={this.props.restart}
        >
          &lt; Back
        </button>
      </div>
    );
  }
}

export default ClinicalToolFlow;
